import React from "react"
import { CheckCircleIcon, Icon } from "@chakra-ui/icons"
import styled from "@emotion/styled"

const Circle = styled.circle`
  cx: 100;
  cy: 100;
  r: 85;
  fill: transparent;
  stroke: currentColor;
  stroke-width: 15;
`
const CircleIcon = (props): JSX.Element => (
  <Icon viewBox="0 0 200 200" {...props}>
    <Circle />
  </Icon>
)

export default function StepStatusIndicator({ isComplete }: { isComplete?: boolean }): JSX.Element {
  return <>{isComplete ? <CheckCircleIcon width="24px" height="24px" /> : <CircleIcon width="24px" height="24px" />}</>
}
